import { render, staticRenderFns } from "./inicio.vue?vue&type=template&id=80aa1e94&scoped=true&"
import script from "./inicio.vue?vue&type=script&lang=ts&"
export * from "./inicio.vue?vue&type=script&lang=ts&"
import style0 from "./inicio.vue?vue&type=style&index=0&id=80aa1e94&prod&scoped=true&lang=css&"
import style1 from "./inicio.vue?vue&type=style&index=1&id=80aa1e94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80aa1e94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
